/* eslint-disable @typescript-eslint/no-empty-function */
import { bool, func, number, string } from 'prop-types';
import { Button } from 'semantic-ui-react';
import ErrorImg from 'Assets/images/pages/web-chat/error.svg';
import classNames from 'classnames';
import React from 'react';

import css from './ControlButton.less';

function ControlButton({
  icon,
  onClick,
  size,
  background,
  disabled,
  gray,
  showError,
  isAttentionAudio,
}) {
  const imgSize = size - 18;
  const className = classNames(css.container, { [css.attention]: isAttentionAudio });
  return (
    <Button
      circular
      disabled={disabled}
      onClick={onClick}
      className={className}
      style={{ width: `${size}px`, height: `${size}px`, backgroundColor: background }}>
      <img
        src={icon}
        alt="button"
        style={{
          width: `${imgSize}px`,
          height: `${imgSize}px`,
          filter: gray ? 'brightness(0.5) invert(1)' : 'none',
        }}
      />
      {showError && <img src={ErrorImg} className={css.error} alt="err" />}
    </Button>
  );
}

ControlButton.propTypes = {
  icon: string.isRequired,
  onClick: func,
  size: number,
  disabled: bool,
  isAttentionAudio: bool,
  background: string,
  gray: bool,
  showError: bool,
};

ControlButton.defaultProps = {
  background: '#1B1E2199',
  gray: false,
  size: 48,
  disabled: false,
  showError: false,
  isAttentionAudio: false,
  onClick: () => {},
};

export default ControlButton;
